/**
 * Direct URLs into the consultant slider, most specific first.
 *
 * react-router 4 matches the whole array as one alternation and reads the
 * params key by key across every pattern, so a name shared by two patterns is
 * overwritten by the pattern that did not match (CRMDEV-7560: the contract
 * link lost its consultant id). Keep the param names distinct.
 */
export const consultantDirectRoutes = (url: string) => [
  // ERP-741 — `/consultants/:id/contract/new?…` is how the ERP links here
  // when it is not embedded in this app. Listed first: the generic pattern
  // below would otherwise swallow it with action1 = "contract".
  `${url}/:contractConsultantId/contract/:contractId?`,
  `${url}/:consultantId/:action1?`
];
